export const ProviderManage = {
  list: [],
  error: '',
  loading: false
}
